import { Twitter, Linkedin, Link2 } from "lucide-react";
import { toast } from "sonner";

const ShareRow = ({ title, path }) => {
  const url = `https://smartnagarnigam.com${path}`;
  const text = encodeURIComponent(`${title} — Smart Nagar Nigam`);
  const encoded = encodeURIComponent(url);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Could not copy link");
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="share-row">
      <span className="text-xs uppercase tracking-[0.25em] text-white/40">Share</span>
      <a data-testid="share-x" href={`https://twitter.com/intent/tweet?text=${text}&url=${encoded}`} target="_blank" rel="noopener noreferrer" aria-label="Share on X" className="border border-white/15 p-3 text-white/60 transition-colors duration-300 hover:border-gold hover:text-gold">
        <Twitter size={16} />
      </a>
      <a data-testid="share-linkedin" href={`https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`} target="_blank" rel="noopener noreferrer" aria-label="Share on LinkedIn" className="border border-white/15 p-3 text-white/60 transition-colors duration-300 hover:border-gold hover:text-gold">
        <Linkedin size={16} />
      </a>
      <a data-testid="share-whatsapp" href={`https://wa.me/?text=${text}%20${encoded}`} target="_blank" rel="noopener noreferrer" aria-label="Share on WhatsApp" className="border border-white/15 p-3 text-white/60 transition-colors duration-300 hover:border-gold hover:text-gold">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm5.1 13.9c-.2.6-1.2 1.2-1.7 1.2-.4.1-1 .1-1.6-.1a13 13 0 0 1-5.7-5c-.8-1.3-1-2.3-.8-2.7.1-.4.9-1.5 1.3-1.6.3-.1.6 0 .8.4l.9 1.6c.1.2 0 .5-.1.7l-.5.7c-.1.2-.2.4 0 .7.5.9 1.9 2.3 3.2 2.9.3.2.5.1.7-.1l.8-.9c.2-.2.4-.3.7-.2l1.7.8c.4.2.5.4.4.7Z"/></svg>
      </a>
      <button data-testid="share-copy" onClick={copy} aria-label="Copy link" className="border border-white/15 p-3 text-white/60 transition-colors duration-300 hover:border-gold hover:text-gold">
        <Link2 size={16} />
      </button>
    </div>
  );
};

export default ShareRow;
